export default {
  name: 'transaction_customer_is_anonymous',
  component_path: 'modules/procedures/blocks/BlockInputCheckbox'
}